import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import StartBoxSection from '../sections/StartBoxSection'
import TitleSection from '../sections/TitleSection'

const StartPage = () => {
  return (
    <div className='__page-container'>
        <Navbar />
        <TitleSection singleLine={false} title="Hvor modstandsdygtig er din virksomhed?" body="Testen er designet til at evaluere din virksomheds evne til at håndtere uforudsigelige hændelser og modstå forstyrrelser, som kan påvirke din virksomheds drift og forretning. "/>
        <StartBoxSection />
        <Footer />
    </div>
  )
}

export default StartPage